/**
 * Carrega modals.js só na primeira interação do usuário.
 * Não carregar no idle/timeout — isso injeta JS durante o Lighthouse e infla o TBT.
 */
(function () {
    var loaded = false;
    var marker = document.querySelector("script[data-modals-src]");
    var src    = marker && marker.getAttribute("data-modals-src");

    if (!src) {
        return;
    }

    function loadModals() {
        if (loaded) {
            return;
        }

        loaded     = true;
        var script = document.createElement("script");

        script.src   = src;
        script.defer = true;
        document.body.appendChild(script);
    }

    ["pointerdown", "keydown", "touchstart"].forEach(function (eventName) {
        window.addEventListener(eventName, loadModals, { once: true, passive: true });
    });
}());
